import { FaRegUserCircle } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { BiSolidPackage } from "react-icons/bi";
import { BiSupport } from "react-icons/bi";
import { LuClipboardList } from "react-icons/lu";
import { FaSearch } from "react-icons/fa";


export const dataSidebar = [


    {
        link: "/",
        title: "کاربران",
        icon: <FaRegUserCircle/>,
    },
    // {
    //     link: "/botManagement",
    //     title: "مدیریت ربات",
    //     icon: <AiFillProduct/>,
    //     subItem: [
    //         {
    //             link: "/user/activeUser",
    //             title: "active users",
    //         }
    //     ]
    // },
    {
        link: "/packages",
        title: "پکیج ها",
        icon: <BiSolidPackage/>,

    },
    {
        link: "/category",
        title: "دسته بندی",
        icon: <MdCategory/>,

    },
    {
        link: "/setting",
        title: "تنظیمات",
        icon: <IoMdSettings/>,

    },
    {
        link: "/poshtibani",
        title: "پشتیبانی",
        icon: <BiSupport/>,

    },
    {
        link: "/gozareshat",
        title: "گزارشات",
        icon: <LuClipboardList/>,

    },
    {
        link: "/crawler",
        title: "جست و جو گر",
        icon: <FaSearch></FaSearch>,

    }
]